import type { Config } from "wagmi"

import type { WalletConnectionStore } from "@/domains/wallet"
import { ZapOrchestrator } from "@/domains/minimal-pools-zap/zap-orchestrator"
import { ZapStore } from "@/domains/minimal-pools-zap/zap-store"
import { PortalsApiTransport } from "@/domains/portals/portals-api-transport"

export class ZapOrchestratorFactory {
  /**
   * Creates a new ZapOrchestrator with all required dependencies
   *
   * @param config - Wagmi config for blockchain interactions
   * @param walletConnection - Wallet connection store for getting current address
   * @returns Configured ZapOrchestrator instance
   */
  static create(chainId: number, config: Config, walletConnection: WalletConnectionStore): ZapOrchestrator {
    // Create transports
    const portalsTransport = new PortalsApiTransport()

    // Create store
    const store = new ZapStore()

    // Create orchestrator with all dependencies
    const orchestrator = new ZapOrchestrator(chainId, store, portalsTransport, config, walletConnection)

    return orchestrator
  }
}
